import { FormControl, Grid, TextField } from '@mui/material';
import MDButton from '@components/MDButton';
import { StandaloneAutoCompleteSelect } from '@components/StandaloneAutoCompleteSelect';
import { Combo } from 'types/combo';
import { useMaterialUIController } from 'context';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    search: string;
    setSearch: (value: string) => void;
    goalFilter: string;
    onGoalFilter: (value: string) => void;
    onSearch: () => void;
    onClear: () => void;
}

export const SalesGoalsFilter = ({ search, setSearch, goalFilter, onGoalFilter, onSearch, onClear }: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const { sidenavColor, darkMode } = controller;
    const inputRef = useRef<HTMLInputElement>(null);
    const isMobile = window.innerWidth <= 768;

    const filterOptions: Combo[] = [
        { label: t('metas.todosVendedores'), value: 'all' },
        { label: t('metas.comMeta'), value: 'with' },
        { label: t('metas.semMetaDefinida'), value: 'without' },
    ];

    useEffect(() => { inputRef.current?.focus(); }, []);

    return (
        <Grid container size={{ xs: 12, md: 10 }} spacing={1} alignItems="center">
            <Grid size={isMobile ? 12 : 3}>
                <FormControl fullWidth>
                    <TextField
                        inputRef={inputRef}
                        placeholder={t('metas.buscarVendedor')}
                        size="medium"
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                        onKeyDown={(event) => event.key === 'Enter' && onSearch()}
                        autoComplete="off"
                        sx={{ backgroundColor: darkMode ? '#141c2b' : 'inherit' }}
                    />
                </FormControl>
            </Grid>
            <Grid size={isMobile ? 12 : 3} sx={{ maxWidth: { md: 260 } }}>
                <StandaloneAutoCompleteSelect
                    options={filterOptions}
                    value={goalFilter}
                    onChange={(value) => onGoalFilter(String(value ?? 'all'))}
                    placeholder={t('metas.filtroMeta')}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 'auto' }} sx={{ display: 'flex', gap: 1 }}>
                <MDButton variant="gradient" color={sidenavColor} onClick={onSearch} sx={{ height: 40, minWidth: 110 }}>
                    {t('general.buscar')}
                </MDButton>
                <MDButton variant="gradient" color={sidenavColor} onClick={onClear} sx={{ height: 40, minWidth: 110 }}>
                    {t('general.limpar')}
                </MDButton>
            </Grid>
        </Grid>
    );
};
